import { useQuery } from '@tanstack/react-query';

import type {
  CardView, EventView, FaceAttributesView, HandlerView, SampleView, StreamGroupView, StreamView,
} from './EventApi';
import { useEventApi } from './EventApiProvider';

function useEventQuery(eventId?: string): { data?: EventView } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'event', eventId],
    queryFn: async () => api.getEvent(eventId ?? ''),
    enabled: !!eventId,
  });
}

function useCardQuery(cardId?: string): { data?: CardView } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'card', cardId],
    queryFn: async () => api.getCard(cardId ?? ''),
    enabled: !!cardId,
  });
}

function useFaceAttributeSamplesQuery(faceId?: string): { data?: { samples: SampleView[] } } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'face-attribute-samples', faceId],
    queryFn: async () => api.getFaceAttributeSamples(faceId ?? ''),
    enabled: !!faceId,
  });
}

function useStreamQuery(streamId?: string): { data?: StreamView } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'stream', streamId],
    queryFn: async () => api.getStream(streamId ?? ''),
    enabled: !!streamId,
  });
}

function useHandlerQuery(handlerId?: string): { data?: HandlerView } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'handler', handlerId],
    queryFn: async () => api.getHandler(handlerId ?? ''),
    enabled: !!handlerId,
  });
}

function useFaceAttributesQuery(faceId?: string): { data?: FaceAttributesView } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'face-attributes', faceId],
    queryFn: async () => api.getFaceAttributes(faceId ?? ''),
    enabled: !!faceId,
  });
}

function useStreamGroupsQuery(): { data?: StreamGroupView[] } {
  const api = useEventApi();

  return useQuery({
    queryKey: ['event-api', 'stream-groups'],
    queryFn: async () => api.getStreamGroups(),
  });
}

export {
  useEventQuery, useCardQuery, useFaceAttributeSamplesQuery, useFaceAttributesQuery,
  useHandlerQuery, useStreamGroupsQuery, useStreamQuery,
};
